import { render, staticRenderFns } from "./Survey.PageTitle.Editor.vue?vue&type=template&id=86712620&scoped=true&"
import script from "./Survey.PageTitle.Editor.vue?vue&type=script&lang=js&"
export * from "./Survey.PageTitle.Editor.vue?vue&type=script&lang=js&"
import style0 from "./Survey.PageTitle.Editor.vue?vue&type=style&index=0&id=86712620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86712620",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDialog,VIcon,VRow,VTextField,VTextarea,VTooltip})
